import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import type { CreateActionBulkModalButtonProps as Props } from './types';

export const CreateActionBulkModalButton = memo(
  ({ className, disabled, children, startIcon, onClick, ...props }: Props) => {
    return (
      <Styled.Wrapper
        className={classnames('CreateActionBulkModalButton', className)}
        startIcon={startIcon ?? <Icon name="plus" />}
        {...props}
        size="small"
        variant="contained"
        color="primary"
        children={children ?? 'Create'}
        disabled={disabled}
        onClick={onClick}
      />
    );
  }
);

CreateActionBulkModalButton.displayName = 'CreateActionBulkModalButton';
